import { PRIVACY_URL } from '../../lib/constants';

// ENTWURF (DSGVO) – vor Go-live anwaltlich bzw. über eRecht24 freigeben.
// Kurzer Hinweis statt Pflicht-Häkchen: Die Einwilligung erfolgt mit dem
// Absenden (conversion-freundlicher, Marketing-Empfehlung). Eine separate
// Marketing-/Newsletter-Einwilligung gibt es im Formular nicht mehr – ein
// Newsletter-Versand käme erst über ein eigenes Double-Opt-In.
// Bei jeder Textänderung CONSENT_TEXT_VERSION in lib/constants.ts hochzählen.
export default function ConsentBlock() {
  return (
    <p className="rf-consent-hint">
      Mit dem Absenden willigst du ein, dass die Randori-Pro Management GmbH deine
      Daten zur Bearbeitung deiner Anfrage nutzt und dich dafür per Telefon, SMS oder
      E-Mail kontaktiert. Widerruf jederzeit möglich. Mehr in der{' '}
      <a className="rf-link" href={PRIVACY_URL} target="_blank" rel="noreferrer">
        Datenschutzerklärung
      </a>.
    </p>
  );
}
